import React from 'react';
import { Switch, Typography } from 'antd';
import { hasLabelsSwitchLabel } from '@/features/datasets/utils/hasLabelsHandling';

const { Text } = Typography;

/**
 * "Does your data contain labels/entities/summaries/outputs?" switch used by
 * the upload modal's Review Labels / Review Outputs steps.
 *
 * Pure presentation: parent owns the state. Default-on is enforced by the
 * parent's per-objective entry shape (see `useUploadModalState`).
 *
 * @param {Object} props
 * @param {boolean} props.checked
 * @param {(checked: boolean) => void} props.onChange
 * @param {string}  [props.taskType] - Drives the noun in the question.
 * @param {string}  [props.label] - Override; defaults from taskType.
 * @param {Object}  [props.style]
 */
const HasLabelsSwitch = ({
    checked,
    onChange,
    taskType,
    label,
    style,
}) => {
    const resolvedLabel = label || hasLabelsSwitchLabel(taskType);
    return (
    <div style={{ marginTop: 0, marginBottom: 16, ...style }}>
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
            }}
        >
            <Text style={{ fontSize: 14, color: '#262626' }}>{resolvedLabel}</Text>
            <Switch checked={checked} onChange={onChange} />
        </div>
    </div>
    );
};

export default HasLabelsSwitch;
